import { render, staticRenderFns } from "./ContactRoleEdit.vue?vue&type=template&id=094012f7&"
import script from "./ContactRoleEdit.vue?vue&type=script&lang=js&"
export * from "./ContactRoleEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports